// graphql_low_score.ts
import { gql, ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import { Query, QueryGetLowScoreVideosArgs, ScoredVideosResult } from '../types/generated/graphql';

export const GET_LOW_SCORE_VIDEOS = gql`
  query GetLowScoreVideos($id: ID!) {
    getLowScoreVideos(id: $id) {
      videos {
        id
        title
        description
        duration
        view_count
        published
        is_live
        is_watched
        thumbnails {
          url
          width
          height
        }
        author {
          id
          name
          thumbnails {
            url
            width
            height
          }
        }
        feedback {
          notInterested {
            token
            undoToken
          }
          dontRecommendChannel {
            token
            undoToken
          }
        }
      }
      scores {
        videoId
        score
        rating
        restricted
        explanation
        restrictingAgents {
          specialization
          version
        }
      }
    }
  }
`;

export function useGetLowScoreVideos(
  client: ApolloClient<NormalizedCacheObject>,
  id: string,
  limit: number = 20
) {
  type T = Pick<Query, 'getLowScoreVideos'>;
  type I = QueryGetLowScoreVideosArgs;

  return useQuery<T, I>(GET_LOW_SCORE_VIDEOS, {
    variables: { id, limit },
    client
  });
}